export async function asyncMap<T, U>(arr: Array<T>, transform: (item: T, index: number) => Promise<U>): Promise<U[]> {
  return arr?.length ? await Promise.all(arr.map((item, index) => transform(item, index))) : ([] as any);
}
